module.exports = __webpack_public_path__ + "static/img/img_5.3e0084ad.jpg";